'use client';

import React from 'react';
import { CheckCircle, AlertCircle, Clock } from 'lucide-react';

const platforms = [
  {
    id: 'plat-li',
    name: 'LinkedIn',
    posts: 42,
    ready: 38,
    pending: 4,
    color: '#0A66C2',
    status: 'aktiv',
  },
  {
    id: 'plat-ig',
    name: 'Instagram',
    posts: 28,
    ready: 21,
    pending: 7,
    color: '#C13584',
    status: 'ausstehend',
  },
  {
    id: 'plat-x',
    name: 'X (Twitter)',
    posts: 35,
    ready: 35,
    pending: 0,
    color: '#ccc',
    status: 'bereit',
  },
  {
    id: 'plat-fb',
    name: 'Facebook',
    posts: 21,
    ready: 18,
    pending: 3,
    color: '#1877F2',
    status: 'aktiv',
  },
  {
    id: 'plat-blog',
    name: 'Blog / SEO',
    posts: 0,
    ready: 0,
    pending: 0,
    color: '#FF5F1F',
    status: 'leer',
  },
];

export default function DashboardPlatformStatus() {
  return (
    <div className="punk-card p-5 h-full">
      <p className="section-label mb-3">Plattform-Status</p>
      <h3 className="text-sm font-600 text-white mb-4">Abdeckung nach Kanal</h3>
      <div className="space-y-3">
        {platforms?.map((p) => {
          const pct = p?.posts > 0 ? Math.round((p?.ready / p?.posts) * 100) : 0;
          return (
            <div key={p?.id} className="space-y-1.5">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: p?.color }} />
                  <span className="text-xs font-500 text-white">{p?.name}</span>
                </div>
                <div className="flex items-center gap-2">
                  {p?.status === 'bereit' && <CheckCircle size={12} className="text-green-400" />}
                  {p?.status === 'ausstehend' && <Clock size={12} className="text-yellow-400" />}
                  {p?.status === 'leer' && <AlertCircle size={12} className="text-red-400" />}
                  {p?.status === 'aktiv' && <CheckCircle size={12} className="text-green-400" />}
                  <span className="mono text-xs text-muted">{p?.posts > 0 ? `${p?.ready}/${p?.posts}` : '—'}</span>
                </div>
              </div>
              <div className="h-1 bg-surface-2 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500"
                  style={{ width: `${pct}%`, background: p?.color }}
                />
              </div>
              {p?.status === 'leer' && (
                <p className="text-xs text-red-400 mono">Keine Beiträge generiert</p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}